import owd from 'owd/owd';
import 'lib/jquery-cookie';

export default class Cookies extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('load', this.dom.$window, () => {
            if($.cookie('agree')) {
                this.$element.remove();
            } else {
                this.$element.addClass('active');
            }
        })
        this.on('click', this.$element.find('.accept'), (e) => {
            e.preventDefault();
            $.cookie('agree', 'true', {
                expries: 365,
                path: '/'
            });
            this.$element.fadeOut();
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('cookies', {
	component: Cookies
});
